import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Date, EAA_Btn } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import PageTitle from '~/components/PageTitle';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';

class AddAndEdit extends Component {
  state={ idData: {}, old_idData: {}, canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getCheckIdDetail, mode = '', setPageText } = this.props;
    const modeInfo = {
      add: {
        title: '清查作業新增',
      },
      edit: {
        title: '清查作業編輯',
      },
    };
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getCheckIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { checkIdDetail: preCheckIdDetail = {} } = preProps;
    const { checkIdDetail = {}, mode } = this.props;
    if (Object.keys(preCheckIdDetail).length === 0 && Object.keys(checkIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ idData: checkIdDetail, old_idData: checkIdDetail });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('CheckIdDetail');
    this.props.clearKey('PageText');
  }

  changeData=({ label = '', data = '' }) => {
    const { idData: body } = this.state;
    const idData = JSON.parse(JSON.stringify(body));
    idData[label] = data;
    this.setState({ idData });
  }

  add=() => {
    this.setState({ canSend: false });
    const { idData } = this.state;
    const { postAddNewCheck } = this.props;
    postAddNewCheck(idData);
  }

  edit=() => {
    this.setState({ canSend: false });
    const { idData } = this.state;
    const { id, putUpdateCheck } = this.props;
    const body = {
      user_check_name: idData.user_check_name,
      start_date: idData.start_date,
      end_date: idData.end_date,
    };
    putUpdateCheck(id, body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });

  filterError=() => {
    const { idData = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnInputDateValue = t => {
      if (t) {
        let text = t;
        while (text.match('/')) {
          text = text.replace('/', '-');
        }
        return text;
      } else {
        return ('');
      }
    };
    const Err_start_end = () => {
      const toItem = text => {
        let t = text;
        const YY = t.substring(0, t.indexOf('-'));
        t = t.substring(t.indexOf('-') + 1);
        const MM = t.substring(0, t.indexOf('-'));
        t = t.substring(t.indexOf('-') + 1);
        const DD = t;
        return ({ YY: parseInt(YY), MM: parseInt(MM), DD: parseInt(DD) });
      };
      const compare = (start, end) => new Date(start.YY, start.MM, start.DD) > new Date(end.YY, end.MM, end.DD);
      if (returnInputDateValue(idData.start_date).length > 0 && returnInputDateValue(idData.end_date).length > 0) {
        return compare(toItem(returnInputDateValue(idData.start_date)), toItem(returnInputDateValue(idData.end_date)));
      } else {
        return false;
      }
    };
    const errorAry = [
      returnInputValue(idData.user_check_name).length === 0,
      returnInputDateValue(idData.start_date).length === 0,
      returnInputDateValue(idData.end_date).length === 0,
      Err_start_end(),
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '', _onClose } = this.props;
    const { idData, canSend, old_idData, errorAry } = this.state;
    const { status = '' } = old_idData;
    // const checkChange = label => isCheck ? userData[label] !== old_userData[label] : false;
    const checkChange = label => isCheck ? (idData[label] || '') !== (old_idData[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnInputDateValue = t => {
      if (t && t.length > 0) {
        return new Date(t);
      } else {
        return ('');
      }
    };
    const returnStateDateValue = d => `${d.getFullYear()}/${(d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : `0${d.getMonth() + 1}`}/${d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`}`;
    const modeInfo = {
      add: {
        title: '清查作業新增',
        sendBtn: '新增',
        func: this._add,
      },
      edit: {
        title: '清查作業編輯',
        sendBtn: '儲存',
        func: this._edit,
      },
    };
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const allRight = errorAry.indexOf(true) === -1;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 23 }} />
        <div style={{ minWidth: '90%', marginLeft: 18, backgroundColor: 'white', boxShadow: '0px 4px 6px rgba(62, 73, 84, 0.04)', borderRadius: 5, paddingLeft: 22 }}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text='清查名稱' bol={true} haveChange={checkChange('user_check_name')} />
                <EAA_Input displayBorder disabled={disabled} hint='AA001' value={returnInputValue(idData.user_check_name)} onChange={data => { this.changeData({ label: 'user_check_name', data }); }} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText text='請輸入名稱' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text='清查日期(起)' bol={true} haveChange={checkChange('start_date')} />
                {/* <MyDateInput disabled={status === '1' || disabled} value={returnInputDateValue(idData.start_date)} onChange={data => { this.changeData({ label: 'start_date', data: returnStateDateValue(data) }); }} /> */}
                <EAA_Date displayBorder disabled={status === '1' || disabled} value={returnInputDateValue(idData.start_date)} onChange={date => { this.changeData({ label: 'start_date', data: returnStateDateValue(date) }); }} />
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText text='請輸入日期' />}
              {errorAry[3] && <EAA_ErrorText text='[清查日期(起)] 不可晚於 [清查日期(迄)]' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text='清查日期(迄)' bol={true} haveChange={checkChange('end_date')} />
                {/* <MyDateInput disabled={disabled} value={returnInputDateValue(idData.end_date)} onChange={data => { this.changeData({ label: 'end_date', data: returnStateDateValue(data) }); }} /> */}
                <EAA_Date displayBorder disabled={ disabled} value={returnInputDateValue(idData.end_date)} onChange={date => { this.changeData({ label: 'end_date', data: returnStateDateValue(date) }); }} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText text='請輸入日期' />}
              {errorAry[3] && <EAA_ErrorText text='[清查日期(起)] 不可晚於 [清查日期(迄)]' />}
            </EAA_Item>
          </EAA_Row>

          <div style={{ display: 'flex', marginTop: 33, marginBottom: 19, width: '100%', justifyContent: 'center' }}>
            {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={_onClose} />}
            {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
            {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
            {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
            {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={_onClose} />}
            {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
            {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
            {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          </div>
        </div>

        <AddRes sucFunc={_onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewCheck' />
        <EditRes sucFunc={_onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutUpdateCheck' />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  checkIdDetail: state.data.CheckIdDetail,
});
const mapDispatchToProps = dispatch => ({
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getCheckIdDetail: id => Actions.getCheckIdDetail(dispatch, { id }),
  postAddNewCheck: body => Actions.postAddNewCheck(dispatch, { body }),
  putUpdateCheck: (id, body) => Actions.putUpdateCheck(dispatch, { id, body }),

  clearKey: key => Actions.clearKey(dispatch, { key }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
